// WhatsApp Consultation Button - Auto Message
(function() {
  // Product title selectors (shared configuration)
  const TITLE_SELECTORS = [
    '.product-info h1',
    '.product-info .h1', 
    '[data-block-type="title"] h1',
    '[data-block-type="title"] .h1',
    '.product-title',
    '.product__title',
    'h1.product-title'
  ].join(', ');
  
  /**
   * Sets up WhatsApp button with auto-populated message
   */
  function setupWhatsAppButton() {
    const whatsappButton = document.querySelector('.whatsapp-button');
    
    if (!whatsappButton) {
      return;
    }
    
    const productTitle = document.querySelector(TITLE_SELECTORS);
    
    if (!productTitle) {
      console.log('Product title not found for WhatsApp message');
      return;
    }
    
    const productName = productTitle.textContent.trim();
    const productUrl = window.location.href;
    const message = `Merhaba, "${productName}" ürünün fiyatını öğrenebilir miyim?

Ürün Linki: ${productUrl}`;
    const encodedMessage = encodeURIComponent(message);
    
    // Update WhatsApp URL with the message
    const currentHref = whatsappButton.getAttribute('href');
    const baseUrl = currentHref.split('?')[0]; // Remove existing parameters
    whatsappButton.setAttribute('href', `${baseUrl}?text=${encodedMessage}`);
    
    console.log('WhatsApp message set for:', productName);
  }
  
  // Initial setup on page load
  document.addEventListener('DOMContentLoaded', setupWhatsAppButton);
  
  // Re-setup when Shopify section loads (for dynamic content)
  document.addEventListener('shopify:section:load', function() {
    setTimeout(setupWhatsAppButton, 100);
  });
})();
